import { apiSlice } from "../../app/api/apiSlice"

export const fieldOptionApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getFieldOptions: builder.mutation({
            query: (broker) => ({
                url: `/fieldoption/${broker}`,
                method: 'GET'
            })
        }),
        getFieldOptionsByCrm: builder.mutation({
            query: (crm) => ({
                url: `/fieldoption/crm/${crm}`,
                method: 'GET'
            })
        })
    })
})

export const {
    useGetFieldOptionsMutation,
    useGetFieldOptionsByCrmMutation
} = fieldOptionApiSlice